import cn from "classnames";
import { Checkbox } from "components/shared/form";
import React, { useState } from "react";
import { applyItem, applyItemEntityOptions, deleteItem } from "sources/books/dictionaries";
import TrailerFamilyForm from "./trailerFamilyForm";

export default function DictionaryOption(props) {
    const [displayNameState, setDisplayName] = useState("");
    const [propertyNameState, setPropertyName] = useState("");
    const [isHiddenState, setIsHidden] = useState(false);
    const [checkedValuesState, setCheckedValues] = useState([]);

    const toEditMode = () => {
        const { changeSelected, id, displayName, propertyName, itemEntityOptions, current, isHidden } = props;
        const checkedPropNames = itemEntityOptions.map((item) => item.propertyName);
        const checkedValues = current.entityOptions.reduce((acc, item) => {
            if (checkedPropNames.includes(item.propertyName)) {
                acc.push(item.id);
            }
            return acc;
        }, []);
        setDisplayName(displayName);
        setPropertyName(propertyName);
        setIsHidden(!!isHidden);
        setCheckedValues(checkedValues);
        changeSelected(id);
    };

    const toShowMode = () => {
        const { changeSelected } = props;
        changeSelected(null);
    };

    const setValue = ({ target }) => {
        setDisplayName(target.value);
    };

    const setHiddenValue = ({ value }) => {
        setIsHidden(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { type, entityType, id } = props.current;
        const nameParams = {
            displayName: displayNameState,
            propertyName: propertyNameState || displayNameState,
            catalogType: type,
            entityType,
            id: props.id,
            catalogId: id,
            ...(type === "NDSType" ? { isHidden: isHiddenState } : {}),
        };
        const optionsParams = { itemId: props.id, values: checkedValuesState };
        const promises = [];
        if (displayNameState !== props.displayName || (type === "NDSType" && isHiddenState !== !!props.isHidden)) {
            promises.push(() => applyItem(nameParams));
        }
        if (checkedValuesState.length !== props.itemEntityOptions.length) {
            promises.push(() => applyItemEntityOptions(optionsParams));
        } else {
            const compareArs = checkedValuesState.some(
                (selectedId) => !props.itemEntityOptions.find((item) => item.id === selectedId),
            );
            if (compareArs) {
                promises.push(() => applyItemEntityOptions(optionsParams));
            }
        }
        return (promises.length ? Promise.all(promises.map((item) => item())) : Promise.resolve()).then(() => {
            toShowMode();
            props.mergeParams({});
        });
    };

    const delOption = () => {
        const { id, mergeParams } = props;
        return deleteItem({ id }).then(() => mergeParams({}));
    };

    const renderOption = ({ id, displayName }) => {
        const present = checkedValuesState.includes(id);
        const cname = cn("d-option__checkbox", { "d-option__checkbox--checked": present });
        const nextValues = present ? checkedValuesState.filter((item) => item !== id) : checkedValuesState.concat(id);
        const action = () => setCheckedValues(nextValues);
        return (
            <div className="col-md-6" key={id}>
                <div className={cname} onClick={action}>
                    {displayName}
                </div>
            </div>
        );
    };

    const renderForm = () => {
        const isNdsType = props.current.type === "NDSType" || props.current.propertyName === "NDSType";
        return (
            <form onSubmit={handleSubmit}>
                <div className="d-option__body">
                    <input
                        className="form-control form-control-sm"
                        type="text"
                        value={displayNameState}
                        name="displayName"
                        onChange={setValue}
                    />

                    {isNdsType && (
                        <Checkbox
                            label="Скрыть тип НДС"
                            labelWrapper="col-auto col-form-label col-form-label-sm pl-0"
                            fieldWrapper="col-auto"
                            wrapper="panel__row"
                            bWrapper="row align-items-center"
                            fieldBeforeLabel
                            inputProps={{ name: "isHidden" }}
                            onChange={setHiddenValue}
                            value={isHiddenState}
                        />
                    )}
                    <div className="d-option__checkboxes row">{props.current.entityOptions.map(renderOption)}</div>
                </div>
                <div className="d-option__actions">
                    <div className="btn btn-secondary btn-sm" onClick={toShowMode}>
                        Отменить
                    </div>
                    <button type="submit" className="btn btn-brand btn-sm">
                        Сохранить
                    </button>
                </div>
            </form>
        );
    };

    const renderTrailerFamilySelect = () => {
        const { id, enums, trailerTypesWithFamily } = props;
        const familyData = trailerTypesWithFamily.find((item) => item.trailerTypeId === id);
        const familyInfo = familyData
            ? enums.trailerFamilyType.find((item) => item.value === familyData.familyTypeId)
            : undefined;
        const showModal = () => {
            props.modal({
                name: "default",
                title: "Выбор группы для прицепов",
                CustomBody: (rest) => (
                    <TrailerFamilyForm
                        {...rest}
                        trailerTypeId={id}
                        trailerFamilyTypes={enums.trailerFamilyType}
                        value={familyInfo?.value}
                        mergeParams={props.mergeParams}
                    />
                ),
            });
        };
        return (
            <span className="mr-2 text-nowrap">
                {familyInfo ? (
                    <>
                        <span className="badge badge-pill badge-primary mr-2">{familyInfo.label}</span>
                    </>
                ) : undefined}
                <small className="link font-size-12" onClick={showModal}>
                    {familyInfo ? "Изменить группу" : "Добавить группу"}
                </small>
            </span>
        );
    };

    const renderBody = () => {
        const { displayName, itemEntityOptions, isDeleted, id, current } = props;

        return (
            <>
                <div className="row">
                    <div className="col-md-7 col-form-label col-form-label-sm">
                        <small className="badge badge-secondary">ID: {id}</small> {displayName}{" "}
                        {isDeleted && <span className="badge badge-danger">Удален</span>}
                    </div>

                    <div className="col-md-5 text-md-right">
                        {!isDeleted && (
                            <>
                                {current.propertyName === "TrailerType" && renderTrailerFamilySelect()}
                                <div className="btn btn-brand btn-xs mr-2 my-sm-1" onClick={toEditMode}>
                                    Изменить
                                </div>
                                <div className="btn btn-danger btn-xs my-sm-1" onClick={delOption}>
                                    Удалить
                                </div>
                            </>
                        )}
                    </div>
                </div>
                {itemEntityOptions.length > 0 && (
                    <div className="row">
                        <div className="col-sm-12 d-option__badges">
                            {itemEntityOptions.map((item) => {
                                return (
                                    <div key={item.id} className="d-option__badge">
                                        {item.displayName}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </>
        );
    };

    const { selected, id } = props;

    return <div className="border-bottom border-secondary py-1">{selected === id ? renderForm() : renderBody()}</div>;
}
